import React, { createContext, useState, useCallback } from "react";

export const MISessionContext = createContext();

export const MISessionProvider = ({ children }) => {
  const [sessionHistory, setSessionHistory] = useState([]);

  const updateSessionHistory = useCallback((newHistory) => {
    setSessionHistory(newHistory);
  }, []);

  const addNewSession = useCallback((newSession) => {
    setSessionHistory((prev) => [newSession, ...prev]);
  }, []);

  const value = {
    sessionHistory,
    setSessionHistory,
    updateSessionHistory,
    addNewSession,
  };

  return (
    <MISessionContext.Provider value={value}>
      {children}
    </MISessionContext.Provider>
  );
};
